class TrackingForm extends HTMLElement {
  constructor() {
    super();

    this._selectors = {
      formWrapper: "[js-form-wrapper]",
      form: "[js-tracking-form]",
      resultsWrapper: "[js-results-wrapper]",
      narvarContainer: "[js-narvar-container]",
      loadingSpinner: "loading-spinner",
      returnBtn: "[js-return-btn]",
      inputs: {
        orderNumber: "input#orderNumber",
        email: "input#email",
      },
    };

    this.form = this.querySelector(this._selectors.form);
    this.formWrapper = this.querySelector(this._selectors.formWrapper);
    this.submit = this.form.querySelector('button[type="submit"]');
    this.orderNumber = this.querySelector(this._selectors.inputs.orderNumber);
    this.email = this.querySelector(this._selectors.inputs.email);

    this.resultsWrapper = this.querySelector(this._selectors.resultsWrapper);
    this.narvarContainer = this.querySelector(this._selectors.narvarContainer);
    this.loadingSpinner = this.querySelector(this._selectors.loadingSpinner);
    this.returnBtn = this.querySelector(this._selectors.returnBtn);
  }

  connectedCallback() {
    this._initEventListeners();
  }

  _initEventListeners() {
    this.form.addEventListener("submit", (event) => this._submitForm(event));
  }

  _toggleView() {
    this.formWrapper.classList.toggle("hidden");
    this.resultsWrapper.classList.toggle("hidden");
  }

  _addMutationObserver() {
    // Initialize MutationObserver
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (
          mutation.type === "attributes" &&
          mutation.attributeName === "height"
        ) {
          console.log("Height of iframe changed");
          this.loadingSpinner.removeAttribute("loading");
          this.returnBtn.classList.remove("hidden");
          observer.disconnect(); // Stop observing if you only want to run the function once
          return;
        }
      });
    });

    // Function to start observing an iframe
    const observeIframe = (iframe) => {
      const config = { attributes: true, attributeFilter: ["height"] };
      observer.observe(iframe, config);
    };

    // Check for existing iframes
    const existingIframes = this.narvarContainer.querySelectorAll("iframe");
    existingIframes.forEach(observeIframe);

    // Observe for new iframes
    const childObserver = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === "childList") {
          for (const node of mutation.addedNodes) {
            if (node.nodeName === "IFRAME") {
              observeIframe(node);
            }
          }
        }
      });
    });

    // Options for the child observer
    const childConfig = { attributes: false, childList: true, subtree: true };

    // Start observing the target element for new iframes
    childObserver.observe(this.narvarContainer, childConfig);
  }

  _submitForm(event) {
    event.preventDefault();

    try {
      this._addMutationObserver();
      let orderNumber = this.orderNumber.value;
      // prepend orderNumber with '#', if it doesn't already have it
      if (!orderNumber.startsWith("#")) {
        orderNumber = "#" + orderNumber;
      }
      window.narvar("track", {
        retailer: "anastasiabeverlyhills",
        order_number: encodeURIComponent(orderNumber),
        email: this.email.value,
      });

      this._toggleView();
    } catch (error) {
      console.log(error);
    }
  }
}

if (!customElements.get("tracking-form")) {
  customElements.define("tracking-form", TrackingForm);
}